import { useMemo } from 'react';
import { useCaseResourcesDataQuery } from '@/queries/case';
import { Case, DraftCase } from '@/api/apis/case';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';
import { DataCacheType } from '@/queries/consts';

export const useCaseDetails = (type: DataCacheType = DataCacheType.Live): Case | DraftCase => {
  const caseData = useBaseCaseDetails();

  const { data: caseResourcesData } = useCaseResourcesDataQuery(caseData.caseId, true, type);

  if (!caseResourcesData) {
    throw new Error('No additional case data provided');
  }

  return useMemo(
    () => ({
      ...caseData,
      ...caseResourcesData,
    }),
    [caseData, caseResourcesData],
  );
};
